function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var convertChunk = function convertChunk(fastqChunk) {
  fastqChunk[0] = '>' + fastqChunk[0].substring(1);
  return fastqChunk.slice(0, 2);
};
var isValidFastq = function isValidFastq(fastqChunk) {
  if (fastqChunk.length !== 4) {
    return false;
  }
  return fastqChunk[0][0] === '@' && fastqChunk[2][0] === '+' && fastqChunk[1].length === fastqChunk[3].length;
};
export var fastqToFasta = function fastqToFasta(sequence) {
  var trimmedSequence = sequence.trim();
  // return unmodified if sequence does not look like fastq
  if (!trimmedSequence.startsWith('@')) {
    return sequence;
  }
  var sequenceLines = trimmedSequence.split('\n');
  var fastaChunks = [];
  for (var i = 0; i < sequenceLines.length; i += 4) {
    var fastqChunk = sequenceLines.slice(i, i + 4);
    if (isValidFastq(fastqChunk)) {
      fastaChunks.push.apply(fastaChunks, _toConsumableArray(convertChunk(fastqChunk)));
    } else {
      // return unmodified sequence if it does not look like valid fastq
      return sequence;
    }
  }
  return fastaChunks.join('\n');
};